<template>
    <div class="flat-mail-calculator-input" id="flat-mail-calculator-input">
        <form class="form-in" v-if="formVisible" @submit="sendFlatMail">
            <div class="form-group">
                <input type="email" name="email" class="form-control"  autocomplete="off" placeholder="E-mail" v-model="email" v-validate="{rules: { required: true, regex: regexRules.email }}">
            </div>
            <div class="btn-send">
                <button class="btn-submit btn-success" type="button" @click="sendFlatMail" :disabled="errors.any()">
                    <svgIcon name="mail-send" class="icon-plane"/>
                </button>
            </div>
        </form>
        <div class="successMessage" v-else>
            <h3>отправлено</h3>
        </div>
    </div>
</template>

<script>
    // import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'formMail',
        props: ['options'],
        data () {
            return {
                formVisible: true,
                email: '',
                regexRules: {
                    email: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            svgIcon,
        },
        // computed: mapGetters({
        // }),
        methods: {
            sendFlatMail(e) {
                e.preventDefault();
                var querystring = require('querystring');
                var urlForm = '/formMailCalculator.php';
                var data = {
                    'mail': this.email,
                    'price' : this.options[0].price,
                    'initPrice' : this.options[0].initPrice,
                    'pricePercent' : this.options[0].pricePercent,
                    'curRate' : this.options[0].curRate,
                    'creditYear' : this.options[0].creditYear,
                    'payPerMonth' : this.options[0].payPerMonth,
                    'totalFlatPrice' : this.options[0].totalFlatPrice,
                    'ovetBankAmount' : this.options[0].ovetBankAmount,
                };
                // console.log(this.options, data)
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        // console.log(data);
                        axios.post(urlForm, querystring.stringify(data));
                       
                    } else {
                        console.log('Form Send mail with errors');
                    }
                });
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-mail-calculator.scss';
    // @import '@/styles/components/forms/forms-respond/form-mail-respond.scss';
</style>